import { BiSun } from "react-icons/bi";
import { IoMenuOutline } from "react-icons/io5";
import { HiMoon } from "react-icons/hi";

interface Props {
  toggleNav: () => void;
  toggleDarkMode: () => void;
  isOpen: boolean;
  isDark: boolean;
  navLinks: string[];
}

export default function StickyNav({
  toggleNav,
  isOpen,
  isDark,
  navLinks,
  toggleDarkMode,
}: Props) {
  return (
    <div className="fixed popup top-3 z-30  grid w-full grid-cols-[1fr,min(600px,100%),1fr] px-4">
      <nav className="col-start-2 shadow-md  backdrop-blur rounded-xl h-16 flex items-center w-full justify-between px-4">
        <img
          className="w-9 h-9 border-primary bg-primary rounded-full"
          src="/assets/img/me.jpg"
          alt="me"
        />

        <ul className="flex relative items-center">
          <button onClick={toggleNav} className="sm:hidden">
            <IoMenuOutline
              id="hamberger"
              className="dark:text-white text-3xl"
            />
          </button>

          {navLinks.map((link, i) => (
            <li className="mx-2 hidden sm:inline" key={i}>
              <a
                href={`#${link}`}
                className="hover:text-primary dark:hover:text-primary dark:text-white transition-colors"
              >
                {link}
              </a>
            </li>
          ))}

          {isOpen && (
            <ul
              id="navbar"
              className="dark:text-slate-400 dark:bg-slate-800 sm:hidden  absolute py-3 top-8 right-5 bg-white w-40 rounded-md shadow-lg dark:shadow-grey"
            >
              {navLinks.map((link, i) => (
                <li key={i} className="flex items-center justify-center py-3">
                  <a href={`#${link}`} className="w-full text-center">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          )}

          <button
            onClick={toggleDarkMode}
            className="p-2 ml-2 bg-grey dark:bg-white rounded-md text-xl sm:text-base"
          >
            {isDark ? <BiSun /> : <HiMoon />}
          </button>
        </ul>
      </nav>
    </div>
  );
}
